export type ArtifactFilter = "all" | "document" | "report" | "chart" | "sheet" | "slides"

type DocLike = { artifactType?: string }

const TYPE_TO_FILTER: Record<string, Exclude<ArtifactFilter, "all">> = {
  markdown: "document",
  html: "report",
  chart: "chart",
  sheet: "sheet",
  slides: "slides",
  svg: "chart",
  mermaid: "chart",
  react: "report",
}

export function artifactTypeFilterKey(doc: DocLike): Exclude<ArtifactFilter, "all"> {
  return TYPE_TO_FILTER[doc.artifactType ?? "markdown"] ?? "document"
}

export function documentMatchesFilter(doc: DocLike, filter: ArtifactFilter): boolean {
  return filter === "all" || artifactTypeFilterKey(doc) === filter
}
